var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"disabled":_vm.disabled,"icon":"","x-small":""},on:{"click":function($event){return _vm.copyText()}}},[_c('v-icon',{attrs:{"size":_vm.iconSize,"color":_vm.copyState}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }